<template>
  <article class="view-invoice-page">
    <div class="heading">
      <AppLogo class="heading-logo"></AppLogo>
      <div class="heading-text-group">
        <h1 class="heading-title">MỘC CHÂU ISLAND</h1>

        <div class="heading-caption">
          Địa chỉ: Mường Sang - Mộc Châu - Sơn La
        </div>
        <div class="heading-caption-group">
          <div class="heading-caption">Tel: 1900 2829</div>
          <div class="divider vertical"></div>
          <div class="heading-caption">Fax: 0212 3768 768</div>
        </div>
        <div class="heading-caption-group">
          <div class="heading-caption">Email: info@mocchauisland.com</div>
        </div>
        <div class="heading-caption-group">
          <div class="heading-caption">Website: mocchauisland.com</div>
        </div>
      </div>
    </div>
    <div class="hr"></div>
    <div class="title-form">
      <div class="heading-title">
        <span></span>
        <h1>Xác nhận đặt phòng</h1>
        <span class="recode">RECODE: {{ bookingDetail.booking_code }}</span>
      </div>
      <div class="heading-summary">
        <span></span>
        <span>Tổng số phòng: {{ bookingDetail.total_room }}</span>
      </div>
      <!-- <h1 class="heading-caption"></h1> -->
    </div>
    <div class="section section-guest-info">
      <div>
        <div class="invoice-info-item">
          <span class="item-label">Từ: </span>MỘC CHÂU ISLAND
        </div>
        <div class="invoice-info-item">
          <span class="item-label">Nhân viên đặt phòng: </span
          >{{ bookingDetail.create_user ?? 'Website đặt phòng' }}
        </div>
        <div class="invoice-info-item">
          <span class="item-label">Ngày tạo: </span
          >{{ bookingDetail.create_date ?? '' }}
        </div>
      </div>
      <div>
        <div class="invoice-info-item">
          <span class="item-label">Người đặt: </span
          >{{ bookingDetail.customer_name ?? '' }}
        </div>
        <div class="invoice-info-item">
          <span class="item-label">Tel: </span
          >{{ bookingDetail.phone_num ?? '' }}
        </div>
        <div class="invoice-info-item">
          <span class="item-label">Email: </span>{{ bookingDetail.email ?? '' }}
        </div>
      </div>
    </div>
    <!-- <el-select v-model="searchParams.sourceId" filterable clearable>
      <el-option
        v-for="item in agencyOptions"
        :key="item.id"
        :label="item.desc"
        :value="item.id"
      >
      </el-option>
    </el-select> -->
    <div style="display: flex; justify-content: space-around">
      <el-checkbox>Mới</el-checkbox>
      <el-checkbox>Sửa</el-checkbox>
      <el-checkbox>Hủy</el-checkbox>
    </div>

    <div class="section section-reservation-table">
      <p style="font-weight: bold">Kính gửi quý khách!</p>
      <p>
        Xin Cảm ơn Quý khách đã lựa chọn MỘC CHÂU ISLAND cho địa điểm lưu trú và
        nghỉ dưỡng tại Mộc Châu, chúng tôi xin gửi quý khách chi tiết xác nhận
        đặt phòng như sau:
      </p>
      <table class="table-reservation">
        <thead>
          <tr>
            <th class="text-bold" rowspan="2">Loại phòng</th>
            <th class="text-bold" rowspan="2" style="max-width: 70px">S.Lượng</th>
            <th class="text-bold" rowspan="1" colspan="2">Thời gian</th>
            <th class="text-bold" rowspan="2" style="max-width: 70px">S.L người (A/C)</th>
            <th class="text-bold" rowspan="2">Số đêm</th>
            <th class="text-bold" rowspan="2">Giá phòng VND net/phòng/đêm</th>
            <th class="text-bold" rowspan="2">Giảm giá (VND)</th>
            <th class="text-bold" rowspan="2">Tổng (VND)</th>
            <!-- <th class="text-right">Tổng</th> -->
          </tr>
          <tr>
            <th class="text-bold" rowspan="1" colspan="1">Đến</th>
            <th class="text-bold" rowspan="1" colspan="1">Đi</th>

            <!-- <th class="text-right">Tổng</th> -->
          </tr>
        </thead>
        <tbody>
          <tr v-for="(room, index) in bookingDetail.room_list" :key="index">
            <td class="text-left">{{ room?.name }}</td>
            <td>{{ room?.quantity }}</td>
            <td>{{ room?.date_from }}</td>
            <td>{{ room?.date_to }}</td>
            <td>{{ room?.adult_child }}</td>
            <td>{{ room?.num_of_night }}</td>
            <td>{{ room?.price }}</td>
            <td class="text-right">{{ room?.discount || 0 }}</td>
            <td class="text-right">{{ room?.amount }}</td>
          </tr>
          <tr>
            <td class="text-right text-bold" colspan="8">TỔNG CỘNG (VND)</td>
            <td class="text-right text-bold">
              {{ bookingDetail?.total }}
            </td>
          </tr>
          <tr>
            <td class="text-right text-bold" colspan="1">Đã đặt cọc (VND)</td>
            <td class="text-right text-bold" colspan="3">
              {{ $displayCurrency(bookingDetail?.deposit) }}
            </td>
            <td class="text-right" colspan="3">Hạn thanh toán</td>
            <td class="text-right text-bold" colspan="2">
              {{ $displayCurrency(bookingDetail?.amount) }}
            </td>
          </tr>
          <!-- <tr>
            <td class="text-right text-bold" colspan="1">
              Đặt cọc phòng (VND)
            </td>
            <td class="text-right text-bold" colspan="3">
              {{ $displayCurrency(room?.amount) }}
            </td>
            <td class="text-right" colspan="3">Hạn thanh toán</td>
            <td class="text-right text-bold" colspan="1">
              {{ $displayCurrency(room?.amount) }}
            </td>
          </tr> -->
          <tr>
            <td class="text-right text-bold" colspan="1">Còn lại (VND)</td>
            <td class="text-right text-bold" colspan="3">
              {{ bookingDetail?.remain }}
            </td>
            <td class="text-right" colspan="3">Hạn thanh toán</td>
            <td class="text-right text-bold" colspan="2">
              {{ earliestDateFrom }}
            </td>
          </tr>
        </tbody>
      </table>
      <p>
        <strong>Số lượng khách: </strong>
        <strong>{{ bookingDetail.adult }}</strong> Người lớn /
        <strong>{{ bookingDetail.child }}</strong> Trẻ em. Nếu phát sinh thêm
        trẻ em hoặc người lớn khác, phụ phí theo quy định khách sạn trực tiếp
        tại quầy.
      </p>
      <div v-if="bookingDetail">
        <div v-for="item in guideFlags" :key="item.flag" class="guide">
          <p>
            Giá phòng <strong>{{ item.name }}</strong> đã bao gồm các dịch vụ và
            tiện ích sau:
          </p>
          <ul>
            <li>Vé tham quan khu du lịch Mộc Châu Island.</li>
            <li>
              Bữa sáng tại nhà hàng tre Tabamboo (Nhà hàng bằng Tre Lớn nhất Thế
              giới).
            </li>
            <li
              v-if="
                item.flag !== 'is_nebula_hotel' &&
                item.flag !== 'is_nebula_level'
              "
            >
              Đồ chào mừng.
            </li>
            <li>Xe điện đưa đón Nội khu trong suốt thời gian lưu trú.</li>
            <li>Trà café, nước lọc.</li>
            <li>Bể bơi vô cực The Soleil Infinity Pool (Vui lòng chuẩn bị theo đồ bơi).</li>
            <li>Khu vui chơi ngoài trời cho trẻ em.</li>
            <li>Bãi đỗ xe miễn phí cho khách.</li>
            <li>Truy cập Internet tốc độ cao.</li>
            <li>Phí phục vụ và VAT.</li>
          </ul>
        </div>
      </div>

      <!-- <table class="note-table">
        <tr>
          <td>Ghi chú</td>
          <td></td>
        </tr>
      </table> -->
    </div>
    <div>
      <div class="rule">
        <p class="title">1. Quy định về thêm người</p>
        <div v-if="bookingDetail.is_bullet_hotel" class="KS đoàn tàu">
          <ul>
            <li class="title italic">
              Phòng / Room: Pullman (VIP) / Couchette:
            </li>
            <li style="list-style-type: none">
              <ul style="list-style-type: circle">
                <li>Trẻ em dưới 4 tuổi: Tối đa 2 trẻ em miễn phí ngủ cùng.</li>
                <li>Trẻ em từ 4 đến dưới 12 tuổi:</li>
                <li style="list-style-type: none">
                  <ul style="list-style-type: square">
                    <li>
                      Phụ thu 200.000vnđ/trẻ/đêm: Bao gồm ăn sáng, không kê thêm
                      giường phụ;
                    </li>
                    <li>
                      Phụ thu 250.000vnđ/trẻ/đêm: Bao gồm ăn sáng, Kê thêm 01
                      giường phụ, tối đa 1 giường phụ/ phòng.
                    </li>
                  </ul>
                </li>
                <li>Trẻ em từ 12 tuổi trở lên và người lớn:</li>
                <li style="list-style-type: none">
                  <ul style="list-style-type: square">
                    <li>
                      Phụ thu 300.000vnđ/người/đêm: Bao gồm ăn sáng, không kê
                      thêm giường phụ;
                    </li>
                    <li>
                      Phụ thu 400.000vnđ/người/đêm: Bao gồm ăn sáng, Kê thêm 01
                      giường phụ.
                    </li>
                  </ul>
                </li>
              </ul>
            </li>
          </ul>
          <ul>
            <li class="title italic">
              Phòng / Room: Roomette (phòng 06 người / 06 PAX):
            </li>
            <li style="list-style-type: none">
              <ul style="list-style-type: circle">
                <li>
                  Trẻ em dưới 4 tuổi: Miễn phí ngủ ghép giường (Tối đa 6 trẻ
                  em);
                </li>
                <li>
                  Trẻ em từ 4 đến dưới 12 tuổi: Phụ thu 150.000 vnđ/người/đêm,
                  bao gồm ăn sáng, không kê thêm giường phụ;
                </li>
                <li>Trẻ em từ 12 tuổi trở lên và người lớn: Không hỗ trợ ở ghép.</li>
              </ul>
            </li>
          </ul>
        </div>
        <div v-if="bookingDetail.is_village_hotel" class="KS làng cổ tích">
          <ul>
            <li class="title italic">Phòng / Room: Lune Village:</li>
            <li style="list-style-type: none">
              <ul style="list-style-type: circle">
                <li>Trẻ em dưới 4 tuổi: Tối đa 2 trẻ em miễn phí ngủ cùng.</li>
                <li>Trẻ em từ 4 đến dưới 12 tuổi:</li>
                <li style="list-style-type: none">
                  <ul style="list-style-type: square">
                    <li>
                      Phụ thu 200.000vnđ/trẻ/đêm: Bao gồm ăn sáng, không kê thêm
                      giường phụ;
                    </li>
                    <li>
                      Phụ thu 250.000vnđ/trẻ/đêm: Bao gồm ăn sáng, kê thêm 1
                      giường phụ, tối đa 1 giường phụ/ phòng.
                    </li>
                  </ul>
                </li>
                <li>Trẻ em từ 12 tuổi trở lên và người lớn:</li>
                <li style="list-style-type: none">
                  <ul style="list-style-type: square">
                    <li>
                      Phụ thu 300.000vnđ/người/đêm: Bao gồm ăn sáng, không kê
                      thêm giường phụ;
                    </li>
                    <li>
                      Phụ thu 400.000vnđ/người/đêm: Bao gồm ăn sáng, Kê thêm 01
                      giường phụ.
                    </li>
                  </ul>
                </li>
              </ul>
            </li>
          </ul>
        </div>
        <div v-if="bookingDetail.is_thai_hotel" class="KS Nhà sàn Thái">
          <ul>
            <li class="title italic">Phòng / Room: Thai Village:</li>
            <li style="list-style-type: none">
              <ul style="list-style-type: circle">
                <li>Trẻ em dưới 4 tuổi: Tối đa 2 trẻ em miễn phí ngủ cùng.</li>
                <li>Trẻ em từ 4 đến dưới 12 tuổi:</li>
                <li style="list-style-type: none">
                  <ul style="list-style-type: square">
                    <li>
                      Phụ thu 200.000vnđ/trẻ/đêm: Bao gồm ăn sáng, không kê thêm
                      giường phụ;
                    </li>
                    <li>
                      Phụ thu 250.000vnđ/trẻ/đêm: Bao gồm ăn sáng, kê thêm 1
                      giường phụ, tối đa 1 giường phụ/ phòng.
                    </li>
                  </ul>
                </li>
                <li>Trẻ em từ 12 tuổi trở lên và người lớn:</li>
                <li style="list-style-type: none">
                  <ul style="list-style-type: square">
                    <li>
                      Phụ thu 300.000vnđ/người/đêm: Bao gồm ăn sáng, không kê
                      thêm giường phụ;
                    </li>
                    <li>
                      Phụ thu 400.000vnđ/người/đêm: Bao gồm ăn sáng, Kê thêm 01
                      giường phụ.
                    </li>
                  </ul>
                </li>
              </ul>
            </li>
          </ul>
        </div>
        <div v-if="bookingDetail.is_nebula_hotel" class="KS Nebula">
          <ul>
            <li class="title italic">Phòng / Room: Nebula Glamping:</li>
            <li style="list-style-type: none">
              <ul style="list-style-type: circle">
                <li>Trẻ em dưới 4 tuổi: Tối đa 2 trẻ em miễn phí ngủ cùng.</li>
                <li>Trẻ em từ 4 đến dưới 12 tuổi:</li>
                <li style="list-style-type: none">
                  <ul style="list-style-type: square">
                    <li>
                      Phụ thu 150.000vnđ/trẻ/đêm: Bao gồm ăn sáng, không kê thêm
                      giường phụ;
                    </li>
                    <li>
                      Phụ thu 200.000vnđ/trẻ/đêm: Bao gồm ăn sáng, kê thêm 1
                      giường phụ, tối đa 1 giường phụ/ phòng.
                    </li>
                  </ul>
                </li>
                <li>Trẻ em từ 12 tuổi trở lên và người lớn:</li>
                <li style="list-style-type: none">
                  <ul style="list-style-type: square">
                    <li>
                      Phụ thu 200.000vnđ/người/đêm: Bao gồm ăn sáng, không kê
                      thêm giường phụ;
                    </li>
                    <li>
                      Phụ thu 250.000vnđ/người/đêm: Bao gồm ăn sáng, Kê thêm 01
                      giường phụ.
                    </li>
                  </ul>
                </li>
              </ul>
            </li>
          </ul>
        </div>
        <div v-if="bookingDetail.is_camp_hotel" class="KS Camping">
          <ul>
            <li class="title italic">Phòng / Room: Lune Camping:</li>
            <li style="list-style-type: none">
              Trường hợp số người vượt tiêu chuẩn của Lều đã đặt, sẽ áp dụng mức
              phí vào cửa theo quy định của Khu du lịch.
            </li>
          </ul>
        </div>
      </div>
      <div class="rule">
        <p class="title">2. Quy định về giờ nhận/trả phòng</p>
        <p>- Thời gian nhận phòng:</p>
        <ul>
          <li>
            Thời gian nhận phòng từ 14:00 ngày khách đến. Các yêu cầu nhận phòng
            sớm trước 14:00 cần được thông báo trước và có sự xác nhận của khách
            sạn tuỳ theo công suất, tình trạng phòng sẵn có nhưng không sớm hơn
            12:00 ngày khách đến.
          </li>
          <li>Nhận phòng trước 06:00 sáng: Chịu phí 100% tiền phòng.</li>
          <li>Nhận phòng từ 06:00 – 12:00: Chịu phí 50% tiền phòng.</li>
        </ul>
        <p>- Thời gian trả phòng:</p>
        <ul>
          <li>Thời gian trả phòng không muộn hơn 12:00.</li>
          <li>
            Quý khách có thể trả phòng muộn tuỳ theo tình trạng phòng sẵn có
            được khách sạn xác nhận.
          </li>
          <li>Trả phòng muộn từ 12:00 – 15:00: Chịu phí 30% tiền phòng.</li>
          <li>Trả phòng muộn từ 15:00 – 18:00: Chịu phí 50% tiền phòng.</li>
          <li>Trả phòng muộn sau 18:00: Chịu phí 100% tiền phòng.</li>
        </ul>
        <p>
          Sau khi hoàn thành các thủ tục nhận phòng, quý khách cần thanh toán
          tiền giá gói phòng cho toàn bộ khoảng thời gian lưu trú đã đăng ký với
          khách sạn, không phụ thuộc vào việc khách trả phòng trước thời gian
          trả phòng.
        </p>
      </div>
      <div class="rule">
        <p class="title">3. Quy định về dịnh vụ tính phí</p>
        <ul>
          <li>Minibar.</li>
          <li>Dịch vụ giặt là.</li>
          <li>Dịch vụ ăn uống.</li>
          <li>Gọi điện thoại ra ngoài.</li>
          <li>Dịch vụ vui chơi giải trí có tính phí.</li>
          <li>Tổ chức trọn gói Dịch vụ tiệc, Hội nghị, Hội thảo.</li>
        </ul>
      </div>
      <div class="rule">
        <p class="title">4. Quy định về thú cưng</p>
        <p>Khách sạn cho phép khách lưu trú mang theo không quá 2 thú cưng/phòng. Mức phụ thu:</p>
        <ul>
          <li>250.000 VNĐ/thú cưng(≤ 7Kg).</li>
          <li>500.000 VNĐ/thú cưng (> 7Kg).</li>
        </ul>
        <p>Khách hàng đồng ý và cam kết với việc sẽ tuân thủ quy định, giữ gìn sạch sẽ, dọn dẹp vệ sinh và coi giữ thú cưng, không làm ảnh hưởng, gây mất vệ sinh hoặc hư hại tài sản của Khách sạn, Khu du lịch & khách hàng khác trong suốt quá trình lưu trú tại Khu du lịch. </p>
        <ul>
          <li>Khi check in: Cần điền form bản cam kết về đảm bảo an toàn của thú cưng, cùng với giấy phép tiêm chủng hoặc sổ khám sức khoẻ.</li>
          <li>
            Đối với các trường hợp không giải trình, quý khách cần nộp phạt phí 1.000.000 VNĐ/thú cưng hoặc có thể bị mời ra khỏi khách sạn( miễn hoàn các thanh toán trước đó) trong trường hợp cố ý không hợp tác và làm sai quy định.
          </li>
        </ul>
      </div>
      <div class="rule">
        <p class="title">5. Quy định về hoàn, huỷ dịch vụ</p>
        <p class="title italic">5.1. Quy định thay đổi thông tin dịch vụ</p>
        <ul>
          <li>
            Đối với ngày Lễ Tết, yêu cầu thông tin người sử dụng dịch vụ phải
            đúng với thông tin người đã được xác nhận dịch vụ từ Mộc Châu
            Island;
          </li>
          <li>
            Trong trường hợp khách hàng nhượng lại đặt phòng đã được xác nhận,
            phải thông báo và nhận được sự đồng ý từ Mộc Châu Island. Khách hàng
            cam kết nhượng lại cho bên/người thứ ba không quá giá phòng niêm yết
            của Mộc Châu Island; Trường hợp Mộc Châu Island phát hiện việc đơn
            giá nhượng lại cho bên/người thứ ba cao hơn giá niêm yết, Mộc Châu
            Island có quyền yêu cầu khách hàng hoàn lại toàn bộ số tiền chênh
            lệch cao hơn đó lại cho bên/người thứ ba, hoặc/và có quyền huỷ không
            hoàn lại hay từ chối cung cấp dịch vụ lưu trú.
          </li>
        </ul>
        <p class="title italic">5.2. Quy định hoàn, hủy dịch vụ</p>
        <p class="italic">Đối với giai đoạn thường:</p>
        <ul>
          <li>
            Quý khách hủy/ đổi phòng trước 14 ngày trước ngày đến, việc huỷ
            phòng sẽ không tính phí.
          </li>
          <li>
            Quý khách hủy/ đổi phòng trong vòng 08 - 14 ngày trước ngày đến, Quý
            khách sẽ chịu phạt 50% tổng chi phí phòng trong toàn bộ thời gian
            lưu trú.
          </li>
          <li>
            Quý khách hủy/ đổi phòng trong vòng 07 ngày trước ngày đến, Quý
            khách sẽ chịu phạt 100% của tổng chi phí phòng trong toàn bộ thời
            gian lưu trú.
          </li>
          <li>
            Đối với những đơn đặt phòng đã được xác nhận mà khách không đến và
            không có xác nhận hủy phòng theo quy định, cần thanh toán 100 % giá
            trị đơn đặt phòng đó.
          </li>
        </ul>
        <p class="italic">Đối với giai đoạn ngày Lễ, Tết:</p>
        <ul>
          <li>Quý khách vui lòng thanh toán toàn bộ giá trị đặt phòng.</li>
          <li>Quý khách sẽ không thể thay đổi về ngày và tên khách.</li>
          <li>
            Quý khách huỷ/ đổi phòng trước 60 ngày trước ngày đến sẽ được chấp
            nhận và không tính phí.
          </li>
          <li>
            Quý khách huỷ/ đổi phòng trong vòng 31 – 60 ngày trước ngày đến, quý
            khách sẽ chịu phạt 50% tổng chi phí phòng trong toàn bộ thời gian
            lưu trú.
          </li>
          <li>
            Quý khách huỷ/ đổi phòng trong vòng 30 ngày trước ngày đến, quý
            khách sẽ chịu phạt 100% tổng chi phí trong toàn bộ thời gian lưu
            trú.
          </li>
          <li>
            Đối với những đơn đặt phòng đã được xác nhận mà khách không đến và
            không có xác nhận hủy phòng theo quy định, cần thanh toán 100 % giá
            trị đơn đặt phòng đó.
          </li>
          <li>
            Trong trường hợp bất khả kháng (thiên tai, dịch bệnh, chiến tranh):
            Khách sạn sẽ hỗ trợ khách nhượng lại đặt phòng. Khách sạn chỉ thực
            hiện hoàn hủy cho khách sau khi phòng đã hủy có đặt phòng thay thế.
          </li>
        </ul>
      </div>
    </div>
    <div
      class="section"
      style="margin-top: 20px; display: grid; grid-template-columns: 1fr 1fr"
    >
      <p style="font-weight: bold">Thông tin tài khoản</p>
      <div style="font-weight: bold">
        <div>
          Tên Tài khoản : CÔNG TY CỔ PHẦN DU LỊCH VÀ TRUYỀN THÔNG MỘC CHÂU GO - CHI NHÁNH MỘC CHÂU
        </div>
        <div>Số tài khoản: 113002911000</div>
        <div>Tên ngân hàng: VIETINBANK - CHI NHÁNH SƠN LA</div>
      </div>
    </div>
    <div
      class="section"
      style="
        font-weight: 600;
        display: grid;
        grid-template-columns: 1fr 1fr;
        align-items: center;
      "
    >
      <div>
        <p>By Confirm</p>
        <p>{{ bookingDetail.create_user }}</p>
      </div>
      <div>
        <p>Trân trọng.</p>
        <p>Sales & Marketing Department</p>
      </div>
    </div>
  </article>
</template>
<script>
/* eslint-disable */
import { getConfirmBooking } from '@/api/booking_service/bookingGroup'
import { getConfirmBookingWithDiscount } from '@/api/booking_service/bookingGroup'
import { displayCurrency } from '@/utils/helper'
import { getUserDetailApi } from '@/api/profile/profile'
import AppLogo from '@/components/AppLogo.vue'
export default {
  components: {
    AppLogo
  },

  computed: {
    guideFlags() {
      if (!this.bookingDetail) return []

      const nameMap = {
        is_bullet_hotel: 'Khách sạn Đoàn tàu (The Bullet Hotel)',
        is_camp_hotel: 'Khu cắm trại (Lune Camping)',
        is_camp_level: null,
        is_couchette_level: null,
        is_nebula_hotel: 'Hành tinh Nebula (Nebula Glamping)',
        is_nebula_level: null,
        is_roomette_level: null,
        is_thai_hotel: 'Làng Thái (Thai Village) ',
        is_thai_level: null,
        is_village_hotel: 'Làng cổ tích (Lune Village)',
        is_village_level: null
      }

      return Object.entries(this.bookingDetail)
        .filter(
          ([key, value]) =>
            key.startsWith('is_') && value === true && nameMap[key]
        )
        .map(([key]) => ({
          flag: key,
          name: nameMap[key]
        }))
    },
    earliestDateFrom() {
      const rooms = this.bookingDetail?.room_list || [];

      if (!rooms.length) return '';

      const dates = rooms
        .map(room => {
          if (!room.date_from) return null;
          const [day, month, year] = room.date_from.split('/');
          return new Date(year, month - 1, day);
        })
        .filter(date => date instanceof Date && !isNaN(date));

      if (!dates.length) return '';

      const earliest = new Date(Math.min(...dates));

      const day = String(earliest.getDate()).padStart(2, '0');
      const month = String(earliest.getMonth() + 1).padStart(2, '0');
      const year = earliest.getFullYear();

      return `${day}/${month}/${year}`;
    }
  },

  data() {
    return {
      bookingId: null,
      recodeGroup: null,
      subBookingId: null,
      printer: null,
      deposit: null,
      remain: null,
      total: null,
      bookingDetail: {
        booking_code: null,
        customer_name: null,
        company: null,
        deposit: null,
        email: null,
        rooms: []
      },

      payments: {
        cash: {
          name: 'Tiền mặt',
          amount: null
        },
        card: {
          name: 'Thẻ',
          amount: null
        },
        bank_transfer: {
          name: 'Chuyển khoản',
          amount: null
        },
        foc: {
          name: 'Miễn phí',
          amount: null
        },
        debt: {
          name: 'Công nợ',
          amount: null
        }
      }
    }
  },
  async mounted() {
    this.bookingId = this.$route.query.id
    this.type = +this.$route.query.type
    const applyDiscount = this.$route.query.applyDiscount === 'true'
    // this.bookingId = this.$route.query.id
    // this.customerInfo.company = this.$route.query.company
    // this.customerInfo.from = this.$route.query.from
    // this.customerInfo.to = this.$route.query.to
    // this.customerInfo.address = this.$route.query.address
    const apiCall = applyDiscount
      ? getConfirmBookingWithDiscount
      : getConfirmBooking

    await apiCall({
      code: this.bookingId,
      type: this.type
    }).then(res => {
      this.bookingDetail = { ...res.data }
      // this.deposit = this.bookingDetail.deposit
      //   ? displayCurrency(this.bookingDetail.deposit)
      //   : 0
    })
    // await getUserDetailApi().then(res => {
    //   this.printer = res.data.user
    // })
    this.$nextTick(() => {
      window.print()
    })
  }
}
</script>
<style>
@media print {
  * {
    overflow: visible !important;
  }
  .view-invoice-page {
    max-width: unset;
  }
}
</style>
<style lang="scss" scoped>
p {
  line-height: 2;
}
.title-form {
  .heading-title {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    text-align: center;
    align-items: center;
    margin-bottom: 0px !important;

    h1 {
      font-size: 1.3rem;
    }

    span.recode {
      font-size: 1rem;
      color: red;
      justify-self: end;
      font-weight: bold;
    }
  }
  .heading-summary {
    position: relative;
    text-align: center;
    color: black;
    font-weight: bold;
    font-size: 12pt;
    span {
      font-size: 12pt;
    }
  }
}
.section {
  h2 {
    font-size: 14pt;
  }
}
.section-guest-info {
  margin: 10pt 0;
  border: solid 2px;
  padding: 8pt 15pt;
  display: flex;
  font-weight: bold;
  div {
    flex-basis: 50%;
  }
}
.section-reservation-table {
  table-reservation {
    margin: 20pt 0;
  }
  p {
    margin: 8pt 0 5pt;
  }
  .guide {
    // padding: 20pt 0 0;
    margin-bottom: 5pt;
    p {
      margin: 8pt 0 5pt;
    }
    ul {
      padding: 0 16pt;
      margin: 0;
      li {
        line-height: 2;
      }
    }
  }
  table.note-table {
    margin: 10pt 0;
    td:first-child {
      width: 50pt;
      height: 30pt;
      text-align: center;
    }
  }
}

.rule {
  .title {
    font-weight: 600;
    // font-size: 12pt;

    &.italic {
      font-style: italic;
    }
  }

  .italic {
    font-style: italic;
  }

  p {
    margin: 8pt 0 5pt;
  }
  ul {
    padding: 0 16pt;
    margin: 0;
    li {
      line-height: 2;
    }
  }
}

.view-invoice-page {
  max-width: 200mm;
  margin: 0 auto;
}
.divider.vertical {
  height: 10pt;
  flex-shrink: 0;
  width: 0;
  border-left: 1px solid rgb(156 163 175);
}

.heading-title {
  margin: 0;
  margin-bottom: 8pt;
  font-size: 20pt;
  font-weight: 600px;
  text-transform: uppercase;
}
.heading-caption-group {
  display: flex;
  margin-top: 4pt;
  align-items: center;
  flex-direction: row;
  justify-content: center;
  gap: 6pt;
}
.heading-caption {
  color: #85210c;
  font-weight: bold;
}
.heading-text-group {
  text-align: center;
  height: fit-content;
}
.heading {
  color: #ba1c00;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
}

.heading-logo {
  height: 120pt;
  width: auto;
}
.hr {
  margin-top: 16pt;
  margin-bottom: 16pt;
  border-top: 0.5pt solid #e5e7eb !important;
}

.invoice-info-item {
  display: block;
  margin-top: 0.5rem;
}

.invoice-info-item .item-label {
  // font-weight: 600;
}

.invoice-info-item:first-child {
  margin-top: 0;
}
td,
th {
  text-align: center;
  max-width: 150px;
  word-wrap: break-word;
}
/* Hide scrollbars */
body {
  overflow: hidden !important;
}
table,
td,
th,
tr,
thead {
  border: solid 0.5px #d4d4d4;
}
* {
  font-size: 10pt;
}
thead th {
  font-weight: 500;
}

table td,
table th {
  padding-left: 5px !important;
  padding-right: 5px !important;
}

.section-invoice-info {
  display: grid;
  grid-template-columns: 75% 25%;
}
.section-invoice-info-right {
  text-align: right;
}
.invoice-info-item {
  display: block;
  margin-top: 0.5rem;
}

.invoice-info-item .item-label {
  // font-weight: 600;
}

.invoice-info-item:first-child {
  margin-top: 0;
}
.section-signature {
  page-break-inside: avoid;
  min-height: 80pt;
  margin-top: 30pt;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
}

// .section-summary td {
//   border: solid 0.5px;
//   padding-top: 0 !important;
// }

// .section-summary tr:last-child td {
//   padding-bottom: 0 !important;
// }

// .section-summary {
//   width: fit-content;
//   margin-left: auto;
// }
table td.text-right,
table th.text-right {
  text-align: right;
}

table td.text-bold,
table th.text-bold {
  font-weight: bold;
}

table td.text-left,
table th.text-left {
  text-align: left;
}

table th {
  color: black;
  text-align: center;
  border: 0.5px solid #d4d4d4 !important;
}
table thead {
  background-color: unset;
}

table td:last-child {
  padding-right: 0 !important;
}
// .section-summary td:first-child {
//   font-weight: 500;
//   font-size: 10pt;
//   text-align: right;
// }

// .section-summary td:last-child {
//   text-align: right;
//   padding-left: 20pt !important;
// }
.table-payments,
.table-transactions {
  border-collapse: collapse;
}
.table-payments td,
.table-transactions td,
.table-payments th,
.table-transactions th {
  border: 1px solid black !important;
  padding: 6pt !important;
}
.table-transactions .text-right,
.table-payments .text-right {
  text-align: right;
}
.table-transactions td:last-child,
.table-payments td:last-child {
  padding-right: 6pt !important;
}
</style>
